import {
  classSet,
  Portal,
  useClickOutside,
  useRect,
  useWindowSize
} from '@platform/ui-library';
import {
  FC,
  HTMLAttributes,
  PropsWithChildren,
  useRef
} from 'react';
import styles from './pop-up.module.scss';

export enum Direction {
  left = 'left',
  right = 'right'
}

export type PopUpProps = HTMLAttributes<HTMLDivElement> & PropsWithChildren<{
  /** Direction to display the popup on. */
  direction?: Direction;
  handleClose: () => void;
  refRect?: ReturnType<typeof useRect>[1];
  useBackdrop?: boolean;
}>;

export const PopUp: FC<PopUpProps> = ({
  className,
  direction,
  handleClose,
  refRect,
  useBackdrop,
  ...props
}) => {
  const domElement = useRef<HTMLDivElement>(null);
  useClickOutside(domElement, !useBackdrop ? handleClose : () => null);
  const [windowWidth] = useWindowSize();
  if (!refRect) {
    return null;
  }

  const style = { ...props.style };
  direction ??= (refRect.left >= windowWidth - refRect.right) ? (
    Direction.left
  ) : Direction.right;
  style.top = refRect.top + refRect.height / 2 + 'px';
  if (direction === Direction.left) {
    style.right = windowWidth - refRect.left + 'px';
  } else {
    style.left = refRect.right + 'px';
  }

  return (
    <Portal>
      {useBackdrop && <div className={styles.backdrop} onClick={handleClose} />}
      <div
        className={classSet([
          styles.container,
          className,
          styles[direction]
        ])}
        {...props}
        ref={domElement}
        style={style}
      />
    </Portal>
  );
};
